import { SelectTracksState } from "../../../types/models/store";

const initState = {
    select_tracks: [],
    releaseInfo: {},
    price: {},
    territories: {},
    releaseDate: {},
    promotion: {},
    discs: [],
};

const ReduxState = (state: any = initState, action: any) => {
    switch (action.type) {
        case "SET_SELECT_TRACKS":
            return { ...state, select_tracks: action.payload };
        case "SET_RELEASE_INFO":
            return { ...state, releaseInfo: { ...state.releaseInfo, ...action.payload } };

        case "SET_PRICE":
            return { ...state, price: { ...state.price, ...action.payload } };

        case "SET_TERRITORIES":
            return { ...state, territories: action.payload };

        case "SET_RELEASE_DATE":
            return { ...state, releaseDate: action.payload };

        case "SET_PROMOTION":
            return { ...state, promotion: { ...state.promotion, ...action.payload } };

        case "SET_DISCS":
            return { ...state, discs: action.payload };

        default:
            return { ...state };
    }
};

export default ReduxState;
